import { FC } from "react";
import { Box, Button, Grid, Card, createStyles, makeStyles, Theme } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import QuoteAddonChangeQuantity from "../../quotePage/components/QuoteAddonChangeQuantity";
import { PriceFormat } from "../../../components/typography/PriceFormat";

interface QuoteCartAddonLeftPreviewProps {
  image?: string;
  name: string;
  price: number;
  quantity: number;
  addon?: QuoteLineItem;
  onRemoveAddon?: (addon: QuoteLineItem) => void;
  onChangeQuantity?: (addon: QuoteLineItem, quantity: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    image: {
      margin: "0 auto",
      display: "block",
      width: "100%",
      maxWidth: "15rem"
    }
  })
);

const QuoteCartAddonLeftPreview: FC<QuoteCartAddonLeftPreviewProps> = ({
  image,
  name,
  addon,
  price,
  quantity,
  onRemoveAddon,
  onChangeQuantity
}) => {
  const classes = useStyles();

  const onRemoveAddonItem = function () {
    if (addon && onRemoveAddon) {
      onRemoveAddon(addon);
    }
  };

  const quantitySection =
    addon && onChangeQuantity ? (
      <QuoteAddonChangeQuantity
        addon={addon}
        hideOnSmall={false}
        hideOnMin={false}
        showRecommend={true}
        onChangeQuantity={onChangeQuantity}
        showOneLine={false}
        disabled={false}
      />
    ) : (
      quantity
    );

  const removeButtonSection = addon && (
    <Box textAlign="center">
      <Button size="small" onClick={onRemoveAddonItem} color="secondary" variant="text">
        Remove
      </Button>
    </Box>
  );

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item md={3} xs={4}>
          <Card square>
            <img className={classes.image} src={image} alt={name} />
          </Card>
        </Grid>
        <Grid item md={9} xs={8}>
          <Grid container spacing={3}>
            <Grid item md={8} xs={8}>
              <Box textAlign="left" fontWeight="fontWeightBold" fontSize="1 rem" flexGrow={1}>
                {name}
              </Box>
            </Grid>
            <Grid item md={4} xs={4}>
              <Box fontWeight="fontWeightBold" textAlign="right">
                <PriceFormat value={price} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="baseline">
                <Box>Qty:</Box>
                <Box flexGrow={1} textAlign="center">
                  {quantitySection}
                </Box>
                <Box>{removeButtonSection}</Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuoteCartAddonLeftPreview;
